import { useState } from 'react';
import { LuPencil } from 'react-icons/lu';
import { colors, typography } from '../../../design/tokens';
import { useProjectName } from '../../../view_stores/useProjectConfigStore';
import { useDashboardControlsActions } from '../../../view_stores/useDashboardControlsStore';
import { DashboardMode, WorkspaceSection } from '../../../view_stores/useDashboardControlsStore';

export function ProjectAppNameEditor() {
  const projectName = useProjectName();
  const [isHovering, setIsHovering] = useState(false);
  const { setDashboardMode, setWorkspaceSection } = useDashboardControlsActions();

  const handleEditClick = () => {
    setDashboardMode(DashboardMode.WORKSPACE);
    setWorkspaceSection(WorkspaceSection.SETTINGS);
  };

  return (
    <div
      className="flex items-center gap-2 min-w-0 flex-1"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <span
        className={`${typography.size.base} ${typography.weight.semibold} ${colors.text.primary} truncate`}
      >
        {projectName}
      </span>

      <button
        onClick={handleEditClick}
        className={`flex-shrink-0 transition-opacity duration-200 ${
          isHovering ? 'opacity-100' : 'opacity-0 pointer-events-none'
        } ${colors.hover.opacity}`}
        aria-label="Edit app name"
      >
        <LuPencil size={16} className={colors.text.secondary} />
      </button>
    </div>
  );
}
